import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

const RelatedRecipeCard = ({ recipe }) => {

  const image = getImage(recipe.image)
  
  return (
    <div className='bg-dorot-purple h-full'>
      <Link to={`/project/${recipe.slug}`}>
        {image && (
          <GatsbyImage image={image} alt={recipe.imageAlt} className='h-[151px] md:h-[218px] md:w-full' />
        )}

        <div className='pt-[11px] pl-[7px] pr-[13px] pb-5 md:pl-2.5 md:py-5 md:pr-6.5 lg:pr-7.5'>
          <p className='font-gelica font-semibold text-white text-_1220 md:text-_2025'>{ recipe.title }</p>
        </div>
      </Link>
    </div>
  )
}

export default RelatedRecipeCard
